import { useDispatch } from "react-redux";

import { goToMainBase } from "ducks/location/location";
import { lastProjectSave } from "resources/projects";
import { closeBottomContainer } from "ducks/layout/layout";
import { useAction } from "../useAction";
import { useResetFeatureCard } from "../../modules/FeatureCard/hooks/useResetFeatureCard";
import { api } from "../../evergis/api";
import { RoutePanelName } from "../../appConfig/types";

export const useOpenProject = (pinnedProjectName?: string): VoidFunction => {
  const dispatch = useDispatch();
  const [saveLastProject] = lastProjectSave.use();
  const closeTable = useAction(closeBottomContainer);
  const resetFeatureCard = useResetFeatureCard();

  return useResetFeatureCard(
    async (projectName: string) => {
      const project = projectName || pinnedProjectName;
      const projectWorkspace = api.names.extractResourceWorkspace(project);
      const currentWorkspace = api.account.user?.namespace;

      if (currentWorkspace === projectWorkspace) {
        await saveLastProject({ input: project });
      }

      closeTable();
      dispatch(goToMainBase({ project, panel: RoutePanelName.Layers }));
    },
    [dispatch, resetFeatureCard, pinnedProjectName],
  );
};
